import type { Pin } from '@daily/shared';
import { format } from 'date-fns';

interface PinnedCardProps {
  pin: Pin;
  thumbnailUrl?: string | null;
  compact?: boolean;
  onClick?: () => void;
}

export function PinnedCard({ pin, thumbnailUrl, compact = false, onClick }: PinnedCardProps) {
  const deadline = pin.deadline ? format(new Date(pin.deadline), 'EEE d MMM') : null;
  const meta = (pin.meta ?? {}) as Record<string, string | undefined>;

  return (
    <button
      type="button"
      onClick={onClick}
      className="relative rounded-md p-3.5 grid grid-cols-[56px_1fr] gap-3 items-stretch shadow-sm w-full text-left h-full"
      style={{ background: 'linear-gradient(135deg, #FFE9CE 0%, #FFD4B8 100%)' }}
    >
      <span className="absolute top-2.5 right-2.5 text-sm" aria-hidden>
        📌
      </span>
      <div
        className="rounded-[6px] bg-white overflow-hidden self-center"
        style={{
          transform: 'rotate(-3deg)',
          backgroundImage: thumbnailUrl ? `url(${thumbnailUrl})` : undefined,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          aspectRatio: '3/4',
          boxShadow: '0 4px 8px rgba(26,20,16,0.15)',
        }}
      />
      <div className="flex flex-col justify-center min-w-0">
        <h5 className="text-[10px] font-bold tracking-[0.16em] uppercase text-ink/55 mb-1.5 m-0">
          Pinned · {pin.category}
        </h5>
        <div className="font-serif text-[14px] font-medium leading-tight mb-1 truncate">
          {pin.title}
        </div>
        {deadline && (
          <div className="font-mono text-[9px] text-tomatoDeep font-bold tracking-[0.04em]">
            ⏱ by {deadline}
          </div>
        )}
        {!compact && (meta.cost || meta.event_date) && (
          <div className="text-[10px] text-inkSoft mt-1">
            {[meta.cost, meta.event_date].filter(Boolean).join(' · ')}
          </div>
        )}
      </div>
    </button>
  );
}
